export const _getItemFromLocal = (key) => {
    return window.localStorage.getItem(key);
};

export const _setItemInLocal = (key, value) => {
    window.localStorage.setItem(key, value);
};

export const _removeItemFromLocal = (key) => {
    window.localStorage.removeItem(key);
};
